import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { HStack } from "@design-system/HStack/HStack";
import { Menu } from "@design-system/Menu/Menu.lib";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import viewTableStyles from "@design-system/ViewTable/ViewTable.module.scss";
import { useViewTableMeta } from "@hooks/view/useViewTableMeta";
import { getAgentSkillActions } from "../agentSkillActions";
import { AgentSkillCallbacks } from "../AgentSkillsList";
import { AgentSkillRow } from "../agentSkillsViewConfig";

export const AgentSkillActionsCell = memo(
    ({ row, table }: CellContext<ViewTableFeatures, AgentSkillRow, string>) => {
        const { callbacks, options } = useViewTableMeta<
            AgentSkillCallbacks,
            { canManage: boolean }
        >(table);

        if (!callbacks || !options) {
            return null;
        }

        const menuItems = getAgentSkillActions({
            skill: row.original,
            canManage: options.canManage,
        });

        return (
            <ViewTableCell captureClicks>
                <HStack gap={8} align="center" justify="end">
                    <Menu.More
                        className={viewTableStyles.showOnHover}
                        aria-label="Skill actions"
                    >
                        {menuItems.map((item) => (
                            <Menu.Item
                                key={item.key}
                                destructive={item.key === "delete"}
                                disabled={item.isDisabled}
                                disabledReason={item.reason}
                                onClick={() =>
                                    callbacks.onMenuItemSelect({
                                        key: item.key,
                                        skill: row.original,
                                    })
                                }
                            >
                                {item.label}
                            </Menu.Item>
                        ))}
                    </Menu.More>
                </HStack>
            </ViewTableCell>
        );
    },
);
